<!-- Profile Avatar Button -->
<div class="relative inline-block text-left">
  <button
    mat-icon-button
    [matMenuTriggerFor]="menu"
    class="profile-button avatar-button"
    [style.background-color]="loading ? '#e5e7eb' : avatarColor || '#5035AB'"
    aria-label="User Menu"
    [disabled]="loading"
  >
    @if (loading) {
      <span class="loading-spinner"></span>
    } @else {
      {{ initials }}
    }
  </button>

  <!-- Dropdown Menu -->
  <mat-menu
    #menu="matMenu"
    class="w-56 bg-profile-white rounded-lg shadow-[0_20px_40px_rgba(0,0,0,0.3),_0_10px_20px_rgba(0,0,0,0.2)] overflow-hidden transition-all duration-200 ease-out"
    xPosition="after"
    yPosition="below"
  >
    <!-- User Info Section -->
    <div class="px-4 py-3 border-b border-gray-200">
      <div class="flex items-center gap-3 mb-2">
        <div class="avatar-circle-large" [style.background-color]="avatarColor || '#5035AB'">
          {{ initials }}
        </div>
        <div class="flex-1 min-w-0">
          @if (loading) {
            <div class="flex items-center gap-2">
              <span class="loading-spinner-small"></span>
              <span class="text-sm text-gray-500">Loading...</span>
            </div>
          } @else {
            <p class="text-sm text-gray-900 truncate">{{ fullName }}</p>
            @if (email) {
              <p class="text-xs text-gray-600 truncate">{{ email }}</p>
            }
          }
        </div>
      </div>
    </div>

    <!-- Menu Items -->
    <a
      routerLink="/settings"
      mat-menu-item
      class="flex items-center gap-3 px-4 py-2 hover:bg-gray-100 transition duration-150"
    >
      <mat-icon class="text-gray-600">settings</mat-icon>
      <span class="text-sm font-medium text-gray-800">Settings</span>
    </a>

    <a
      routerLink="/contact-us"
      mat-menu-item
      class="flex items-center gap-3 px-4 py-2 hover:bg-gray-100 transition duration-150"
    >
      <mat-icon class="text-gray-600">contact_mail</mat-icon>
      <span class="text-sm font-medium text-gray-800">Contact Us</span>
    </a>

    <a
      routerLink="/help"
      mat-menu-item
      class="flex items-center gap-3 px-4 py-2 hover:bg-gray-100 transition duration-150"
    >
      <mat-icon class="text-gray-600">help_outline</mat-icon>
      <span class="text-sm font-medium text-gray-800">Help Center</span>
    </a>

    <mat-divider class="my-1"></mat-divider>

    <button
      (click)="logout()"
      mat-menu-item
      class="flex items-center gap-3 px-4 py-2 hover:bg-red-50 transition duration-150"
    >
      <mat-icon class="text-red-600">exit_to_app</mat-icon>
      <span class="text-sm font-medium text-red-600">Logout</span>
    </button>
  </mat-menu>
</div>
